<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <user-form />
  </v-container>
</template>

<script>
import UserForm from './_Form'

export default {
  name: 'DriverMasterUserEdit',
  components: {
    UserForm
  },
  data () {
    return {
      breadcrumbs: [
        { text: 'ユーザ一覧', disabled: false, to: '/driver/masters/users', exact: true },
        { text: 'ユーザ編集', disabled: true, to: '' },
      ],
    }
  },
  created() {
  },
  methods: {}
}
</script>

